import { AssetJobType, AssetMetadata } from "./asset.interface";

export enum PathType {
  remote = "remote",
  resource = "resource",
  asset = "asset",
}

export interface ImageFilter {
  type: "blur" | "blend" | "darken" | "grayscale";
  options?: any;
  intensity?: number;
}

export interface FileObject {
  path: string;
  pathType: PathType | keyof typeof PathType;

  assetId?: string;

  originalFilePath?: string;
  /**
   * The key of the file inside the bucket
   */
  bucketFileKey?: string;

  /**
   * If there is an optimized version of the file, this is where the key is cached
   */
  optimizedFilePath?: string;

  /**
   * If there is an converted file (e.g. removed background or zpt), the result is stored in this key
   */
  convertedFilePath?: string;

  dimensions?: {
    width: number;
    height: number;
  };

  focusPoint?: {
    x: number;
    y: number;
  };

  filters?: ImageFilter[];

  operation?: {
    name: AssetJobType;
  };

  remoteJob?: {
    id: string;
    status: "completed" | "failed" | "pending";
  };

  metadata?: AssetMetadata;
}

export interface DownloadableFileObject extends FileObject {
  path: string;
  pathType: "resource";
  originalFilePath: string;
}

export interface ResolvedFile {
  uri?: string;
}

export function isFileObject(object: any): object is FileObject {
  return typeof object === "object" && typeof object.path === "string";
}
